import type { MapperBundle } from '@/common/application/mappers/kit/mapperTypes';
import { stripUndefined } from '@/common/application/mappers/kit/stripUndefined';

interface DefineMapperOptions<From, To> {
  toView: (input: From) => To;
  toRequest: (input: To) => From;
}

export function defineMapper<From, To>(options: DefineMapperOptions<From, To>): MapperBundle<From, To> {
  const { toView, toRequest } = options;

  return {
    toView,
    toRequest,
    partial: (input) => stripUndefined(toRequest(input as To)) as Partial<From>
  };
}
